import React from 'react'

import ButtonIcon, { shouldRenderButtonIcon } from './button-icon'
import type { ButtonIconProps } from './types'
import isReact from '../../utils/is-react'
import Flex from '../_primitives/flex/flex'
import type { SizeProps } from '../_primitives/types'

const ButtonIconMemo = React.memo(ButtonIcon)

function IconLayout(props: {
  icon: ButtonIconProps
  iconSize?: SizeProps
  isLoading?: boolean
}): JSX.Element {
  const { icon, iconSize, isLoading } = props

  return (
    <>
      {shouldRenderButtonIcon(icon) ? (
        <ButtonIconMemo {...{ icon: icon, iconSize, isLoading }} />
      ) : isReact.element(icon) ? (
        <Flex opacity={isLoading ? 0 : 1}>{icon}</Flex>
      ) : null}
    </>
  )
}

export default IconLayout
